__turbopack_context__.v({
  "AddFavoritesHint": "emoji-picker-module__5pEava__AddFavoritesHint",
  "DraggableEmoji": "emoji-picker-module__5pEava__DraggableEmoji",
  "EmojiGroup": "emoji-picker-module__5pEava__EmojiGroup",
  "EmojiKeyboard": "emoji-picker-module__5pEava__EmojiKeyboard",
  "EmojiPicker": "emoji-picker-module__5pEava__EmojiPicker",
  "EmojiWrapper": "emoji-picker-module__5pEava__EmojiWrapper",
  "FavoriteEmoji": "emoji-picker-module__5pEava__FavoriteEmoji",
  "FavoriteEmojisCount": "emoji-picker-module__5pEava__FavoriteEmojisCount",
  "ManageEmojiPicker": "emoji-picker-module__5pEava__ManageEmojiPicker",
  "ManageFavoriteEmojis": "emoji-picker-module__5pEava__ManageFavoriteEmojis",
  "RemoveEmojiButton": "emoji-picker-module__5pEava__RemoveEmojiButton",
  "SortableEmojis": "emoji-picker-module__5pEava__SortableEmojis",
  "Tooltip": "emoji-picker-module__5pEava__Tooltip",
});
